export default __webpack_public_path__ + "static/media/icon-desentupimento.8903f580.svg";